import React from 'react';
import DecorativeImage from '../DecorativeImage';

const LPWhyYouNeedSection = ({ onOpenModal }) => (
  <section className="py-24 bg-white" data-testid="lp-why-you-need-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        {/* Image — 5 cols */}
        <div className="lg:col-span-5 order-1">
          <DecorativeImage
            src="/assets/img/lp1.webp"
            alt="Modern office"
          />
        </div>
        {/* Content — 7 cols */}
        <div className="lg:col-span-7 order-2">
          <p className="eyebrow mb-4">The Foundation of Value</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] mb-8 tracking-tighter leading-tight">
            Registration isn't optional. It's the standard.
          </h2>
          <div className="space-y-5 font-body text-[#4A5D53]">
            <p className="text-base leading-relaxed">Without federal registration, your brand exists in a legal vacuum. Any competitor can adopt a similar identity, divert your customers, and erode the market position you spent years building.</p>
            <p className="text-base leading-relaxed">A registered trademark transforms your brand into an enforceable legal asset — authority to litigate, qualify for platform protections, and significantly increase your enterprise valuation.</p>
          </div>
          <div className="mt-8 p-6 bg-[#EAE7DF] rounded-2xl border-l-4 border-[#C85A40]">
            <p className="font-body text-sm text-[#111C16] leading-relaxed"><strong>Advisory:</strong> Trademark rights operate on a first-to-file basis. Each day without registration increases the probability of a competing application.</p>
          </div>
          <button
            onClick={() => onOpenModal?.('Why You Need - Register Now')}
            className="mt-8 bg-[#C85A40] hover:bg-[#A64730] text-white font-body font-medium px-8 py-4 rounded-full transition-colors inline-flex items-center gap-2"
            data-testid="lp-why-you-need-cta"
          >
            Register Now
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </button>
        </div>
      </div>
    </div>
  </section>
);

export default LPWhyYouNeedSection;
